import React from 'react'
import { Team } from '../../component/about/Team'

export default function TeamPage() {
  return (
    <>
      <Team />
    </>
  )
}
